import { Component } from '@theme/component';

/**
 * Texte avec icônes — puces du carrousel mobile.
 *
 * Même approche que les avis compacts : écouteur scroll direct et index calculé
 * depuis la position, fiable partout. Les puces sont construites ici car leur
 * nombre dépend des blocs.
 *
 * @typedef {Object} Refs
 * @property {HTMLElement} track
 * @property {HTMLElement[]} cards
 * @property {HTMLElement} [dots]
 *
 * @extends {Component<Refs>}
 */
export class TextWithIcons extends Component {
  requiredRefs = ['track'];

  /** @type {HTMLElement[]} */
  #dots = [];

  connectedCallback() {
    super.connectedCallback();

    const { track, cards } = this.refs;
    if (!cards?.length || !this.refs.dots) return;

    cards.forEach((card, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'twi__dot';
      dot.setAttribute('aria-label', `Élément ${i + 1}`);
      dot.addEventListener('click', () => {
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      });
      this.refs.dots.appendChild(dot);
      this.#dots.push(dot);
    });

    track.addEventListener('scroll', () => this.#paint(), { passive: true });
    this.#paint();
  }

  #paint() {
    const { track } = this.refs;
    if (!this.#dots.length || !track.clientWidth) return;

    const index = Math.min(
      this.#dots.length - 1,
      Math.max(0, Math.round(track.scrollLeft / track.clientWidth))
    );
    this.#dots.forEach((dot, i) => dot.classList.toggle('twi__dot--active', i === index));
  }
}

if (!customElements.get('text-with-icons')) {
  customElements.define('text-with-icons', TextWithIcons);
}
